import React from "react";
import { Link } from "react-router-dom";

export default function BlogCard({ post }) {
  const day = post.publishDate.getDate();
  const month = post.publishDate.toLocaleString("default", { month: "short" });
  const thumbnail = post.featuredImage?.url || "/images/blog/theatre-curtain.jpg";

  return (
    <div className="col-lg-4 col-md-6 mb-5" style={{ padding: "15px" }}>
      <div className="card border-0 rounded-0 hover-shadow h-100 d-flex flex-column">
        <div
          className="card-img position-relative"
          style={{ height: "240px", overflow: "hidden" }}
        >
          <img
            className="card-img-top rounded-0 w-100 h-100"
            style={{ objectFit: "cover", objectPosition: "center center" }}
            src={thumbnail}
            alt={post.featuredImage?.title || post.title}
          />
          <div className="card-date h5">
            <span>{day}</span>
            <br />
            {month}
          </div>
        </div>

        <div className="card-body d-flex flex-column justify-content-between flex-grow-1">
          <div>
            {post.category && (
              <span
                className="badge badge-primary text-white mb-2 text-uppercase"
                style={{ fontSize: "11px", letterSpacing: "1px" }}
              >
                {post.category}
              </span>
            )}
            <h4 className="card-title text-secondary mb-3">
              <Link
                to={post.getLink()}
                style={{ color: "inherit", textDecoration: "none" }}
              >
                {post.title}
              </Link>
            </h4>

            {post.author && (
              <p className="text-muted small mb-2">
                <i className="ti-user text-primary mr-2" />
                By {post.author}
              </p>
            )}

            <p
              className="card-text text-muted"
              style={{
                whiteSpace: "normal",
                lineHeight: "1.6",
              }}
            >
              {post.shortDescription}
            </p>
          </div>

          <div className="mt-3">
            <Link to={post.getLink()} className="btn btn-primary btn-sm">
              Read More <i className="ti-arrow-right ml-1" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
